export default [
	// 会员列表
	{
		path: 'member',
		name: 'm_member',
		props: route => route.params,
		component: () => import('@/pages/mall/member_list')
	},
	// 会员收支记录
	{
		path: '/member/account/record',
		name: 'm_mall_account_record',
		props: route => route.params,
		component: () => import('@/pages/mall/member_account_record_list')
	},
	// 会员收支记录
	{
		path: '/member/deposit/record',
		name: 'm_mall_deposit_record',
		props: route => route.params,
		component: () => import('@/pages/mall/member_deposit_record_list')
	},
	// 首页banner
	{
		path: '/banner',
		name: 'm_mall_banner',
		props: route => route.params,
		component: () => import('@/pages/mall/banner_list')
	},
	// 广告位管理
	{
		path: '/ad_position',
		name: 'm_mall_ad_position',
		props: route => route.params,
		component: () => import('@/pages/mall/ad_position_list')
	},
	// 广告内容管理
	{
		path: '/ad_info',
		name: 'm_mall_ad_info',
		props: route => route.params,
		component: () => import('@/pages/mall/ad_info_list')
	},
	// 商城订单查询
	{
		path: '/order',
		name: 'm_mall_order',
		props: route => route.params,
		component: () => import('@/pages/mall/order_list')
	},
	// 商城商品查询
	{
		path: '/product',
		name: 'm_mall_product',
		props: route => route.params,
		component: () => import('@/pages/mall/product_list')
	}
];
